module.exports = __webpack_public_path__ + "img/ic_niche.b574a210.svg";